import { useArticulosTablePage } from 'context/ArticulosTablePageContext'

const FilterArticulos = () => {
  const { filterByActive, setFilterByActive } = useArticulosTablePage()

  const handleChange = e => {
    setFilterByActive(e.target.value)
  }

  return (
    <select
      className="filtro-articulos-select"
      id="filterActive"
      value={filterByActive}
      onChange={handleChange}
    >
      <option value="all">Todos</option>
      <option value="enabled">Habilitados</option>
      <option value="disabled">Deshabilitados</option>
    </select>
  )
}

export default FilterArticulos
